 /* globals urls, RSVP, KoisLoader */

var $ = jQuery.noConflict();

// New class for Kois Receipts loader functionality
window.KoisReceipts = function(yearFieldSelector, listContainSelector){
    KoisLoader.call( this );

    // Override properties as necessary
    this.yearSelector = yearFieldSelector;
    this.listSelector = listContainSelector;
    this.receipts = {};
    this.validSections = ['customerReceiptList'];
    var self = this;
	this.requestData = {
        action: 'fetch_customer_receipt_list_sections',
        year: function(){
            return self.getCurrentYear();
        }
	};
	this.sectionMappings = {
		customerReceiptList: {id: 'kois-customer-receipts-contain'}
    };
    // Start watching the year select so we can update the list when a new year is selected
    this.watchYearSelect();
};

// Inherit from KoisLoader class
KoisReceipts.prototype = Object.create( KoisLoader.prototype );
KoisReceipts.prototype.constructor = KoisReceipts;

// Get the currently selected year as an int
KoisReceipts.prototype.getCurrentYear = function(){
    return parseInt( $(this.yearSelector).val() ) || 0;
};

// Override section event handler initialization function
KoisReceipts.prototype.initSectionEventHandlers = function(sectionContain, sectionName){
	var section =  $(sectionContain);
	// TODO: Any events to handle?
};

// Start watching the year select to load new receipt data when it changes
KoisReceipts.prototype.watchYearSelect = function(){
    var self = this;
    $(self.yearSelector).change(function(e){
        e.preventDefault();
        self.loadReceiptsList();
    });
};

KoisReceipts.prototype.loadReceiptsList = function(){
	// Setup
    var self = this;
    var sectionsArray = ['customerReceiptList'];
    // Get the currently selected year
    var currentYear = self.getCurrentYear();
    // Get any cached receipt data for this year
    var currentYearReceipts = self.receipts[currentYear];
    var loaderSelector = self.listSelector;
    $(loaderSelector).addClass('loading');
    
    var promise;
    // If we already have this year's receipt data cached, immediately resolve the promise with the cached markup
    if( currentYearReceipts ){
        promise = new self.RSVP.Promise(function( resolve, reject ){
            if( currentYearReceipts ){
                resolve({customerReceiptList: self.receipts[currentYear]});
            }
            reject('An error occurred while attempting to load your data');
        });
    }
    // Otherwise request the data
    else{
        promise = self.requestSections(sectionsArray);
    }
    
    // Update the screen with the resulting receipt markup
    promise.then(function(sectionsMarkup){
        self.initSectionsFrontEnd(sectionsMarkup, sectionsArray);
        // Cache the data
        self.receipts[currentYear] = sectionsMarkup.customerReceiptList;
        $(loaderSelector).removeClass('loading');
    }).catch(function(err){
        self.handleError(err, sectionsArray);
        $(loaderSelector).removeClass('loading');
    });
};